import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, of, throwError } from "rxjs";
import { AppConfig } from "../app.config";
import { BasicResponse } from "../responses/basicResponse";
import { LoggingService } from "./LoggingService";

@Injectable({
    providedIn: 'root'
  })
  export class BillingApiService {
  
    constructor(private httpClient: HttpClient, private appConfig:AppConfig, private logger:LoggingService) { 
    }
  
    get serviceURL():string {
      return this.appConfig.getConfig("billingservice_external_url") + '/api/billing/';
    }
    get optionsJson(){
      return this.appConfig.optionsJson;
    }
    get optionsForm(){
      return this.appConfig.optionsForm;
    }

    /*
    public getStripeApiKey(requestorEntityId:number, requestorEntityType:string,){
      return this.httpClient.get<any>(this.serviceURL+`stripeApiKey/` + (requestorEntityId?(requestorEntityId):'') + (requestorEntityType?('/' + requestorEntityType):''), this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
    }
    */

    public getUpcomingInvoice(requestorEntityId:number, requestorEntityType:string,){
        this.logger.log("Getting upcoming invoice");
        return this.httpClient.get<any>(this.serviceURL+`upcomingInvoice/` + (requestorEntityId?(requestorEntityId):'') + (requestorEntityType?('/' + requestorEntityType):''), this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
    }

    public getBillingItems(requestorEntityId:number, requestorEntityType:string, fromDateTime:Date, toDateTime:Date){
      this.logger.log("Getting billing items");
      return this.httpClient.get<any>(this.serviceURL+`billingItems/` + fromDateTime.toISOString() + '/' + toDateTime.toISOString() + (requestorEntityId?('/' +requestorEntityId):'') + (requestorEntityType?('/' + requestorEntityType):''), this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
    }

    public getHasAutomaticDefaultPayment(requestorEntityId:number, requestorEntityType:string){
      this.logger.log("Getting status of automatic default payment");
      return this.httpClient.get<any>(this.serviceURL+`hasAutomaticDefaultPayment/` + requestorEntityId + '/' + requestorEntityType, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
    }

    public getBillingPortal(requestorEntityId:number, requestorEntityType:string){
      this.logger.log("Getting billing portal");
      return this.httpClient.get<any>(this.serviceURL+`billingPortal/` + requestorEntityId + '/' + requestorEntityType, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
    }

    public createTestInvoice(requestorEntityId:number, requestorEntityType:string, amount:number){
      this.logger.log("Creating test invoice");
      return this.httpClient.get<any>(this.serviceURL+`createTestInvoice/` + requestorEntityId + '/' + requestorEntityType + '/' + amount, this.optionsJson).pipe(catchError((error: any):any => {this.handleError(error); return of (this.createBasicResponseError(error))}));
  }

    private createBasicResponseError(error: HttpErrorResponse){
        let br = new BasicResponse();
        br.success=false;
        br.message='Backend error - please try again later';
        return br;
      }
    
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(()=>(error));
    }
}